import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { NotificationName } from 'utils/constants/notification';

import { setAccountId, setGiftModalVisible, setUserId } from 'store/models/gift';
import { addNotification } from 'store/models/notification';

const createGift = (setLoad, amount) => {
    return (dispatch, getState) => {
        setLoad(true);
        const { accountId, userId } = getState().gift;
        fetcher
            .post(`/api/v1/backoffice/invoices/bonus`, { accountId, userId, amount })
            .then((newInvoice) => {
                dispatch(addNotification(NotificationName.SendBonus));
                if (newInvoice?.id) {
                    dispatch([setAccountId(0), setUserId(0), setGiftModalVisible(false)]);
                    dispatch(push(`/new/admin/invoices/${newInvoice.id}/`));
                }
            })
            .finally(() => {
                setLoad(false);
            });
    };
};

export default createGift;
